export default {
  dbi_overlap_other_vendor_active_users_hover:
    '某款游戏的用户，在同一月份同时游玩其他游戏的用户数量，以及排名前10重叠游戏各自的用户占比。',
  dbi_overlap_other_vendor_data_calculation_country: '数据计算（国家）',
  dbi_overlapanylistis_mobile_title: `手游重叠度分析`,
  dbi_overlapanylistis_steam_title: `Steam游戏重叠度分析`,
  dbi_overlapanylistis_crossusage: '跨应用使用情况',
  'dbi_overlapanylistis_crossusage%': '跨应用使用情况(%)',
  dbi_overlapanylistis_crossaffinity: '跨应用亲和度',
  dbi_overlapanylistis_mau_tabletip:
    '取所选时间段内的平均值。{br}' + '仅提供AppStore和Google Play平台数据，不包含其他第三方平台数据例如中国安卓的数据.',
  dbi_overlapanylistis_crossusage_tabletip: `跨应用使用情况：使用该应用的用户同时使用其他应用的百分比。该指标只有在月粒度下选择单个国家才可用。`,
  dbi_overlapanylistis_crossaffinity_tabletip: `跨应用亲和度：此应用的使用者中其他应用的使用率与一般人群之间的比率。 例如，亲和力为2.0x，意味着Roblox的用户使用其他应用的可能性是一般人群的两倍。`,

  dbi_overlap_current_players: '正在玩',
  dbi_overlap_potential_players: '加愿望清单',

  // 4-segment labels
  dbi_overlapsteam_segment_played_play: '在玩玩家重叠',
  dbi_overlapsteam_segment_played_wishlist: '在玩玩家&加愿望清单用户',
  dbi_overlapsteam_segment_wishlisted_play: '加愿望清单用户&在玩玩家',
  dbi_overlapsteam_segment_wishlisted_wishlist: '加愿望清单用户重叠',
  dbi_overlapsteam_filter_placeholder: '按重叠度%筛选',

  dbi_overlap_country_selector_no_data: '没有分国家数据',
  dbi_mobile_overlap_country_filter_tip: '当前仅支持28个国家，需要了解更多国家/地区的overlap数据，请联系sallyxue',

  dbi_overlapsteam_played_play_front: '和所有Steam游戏相比，',
  dbi_overlapsteam_played_play_middle: ' 的玩家倾向于玩 ',
  dbi_overlapsteam_played_play_after: ' 多于其他游戏，这些游戏的玩家重合度分别为 ',
  dbi_overlapsteam_played_play_after_pp: ' 多于其他游戏，这些游戏的玩家亲密度分别为 ',
  dbi_overlapsteam_played_play_end: '。',

  dbi_overlapsteam_played_wishlist_front: ' ',
  dbi_overlapsteam_played_wishlist_middle: ' 的玩家相比其他steam游戏，更倾向于添加了 ',
  dbi_overlapsteam_played_wishlist_after: ' 游戏到愿望清单中，这些游戏的玩家同时添加愿望清单百分比分别为 ',
  dbi_overlapsteam_played_wishlist_after_pw: ' 游戏到愿望清单中，这些游戏的玩家同时添加愿望清单可能性倍数分别为 ',
  dbi_overlapsteam_played_wishlist_end: '。',

  dbi_overlapsteam_wishlisted_play_front: '和所有Steam游戏相比，添加 ',
  dbi_overlapsteam_wishlisted_play_middle: ' 到愿望清单的玩家倾向于玩 ',
  dbi_overlapsteam_wishlisted_play_after: ' 多于其他游戏，这些游戏的添加愿望清单同时玩游戏的百分比分别为 ',
  dbi_overlapsteam_wishlisted_play_after_wp: ' 多于其他游戏，这些游戏的添加愿望清单同时玩游戏的可能性倍数分别为 ',
  dbi_overlapsteam_wishlisted_play_end: '。',

  dbi_overlapsteam_wishlisted_wishlist_front: '添加 ',
  dbi_overlapsteam_wishlisted_wishlist_middle: ' 到愿望清单的玩家相比其他Steam游戏，更倾向于添加 ',
  dbi_overlapsteam_wishlisted_wishlist_after: ' 游戏到愿望清单中，这些游戏的添加愿望清单同时添加愿望清单分别为 ',
  dbi_overlapsteam_wishlisted_wishlist_after_ww:
    ' 游戏到愿望清单中，这些游戏的添加愿望清单同时添加愿望清单可能性倍数分别为 ',
  dbi_overlapsteam_wishlisted_wishlist_end: '。',

  dbi_overlapsteam_steam_pcu: '最高同时在线玩家',
  dbi_overlapsteam_steam_pcu_info: '北京时间昨天最高的同时（5分钟内）在线玩家。参与度不影响PCU。',
  dbi_overlapsteam_played_play: '游戏玩家重叠度',
  dbi_overlapsteam_pp_overlap_affinity: '游戏玩家亲密度',
  dbi_overlapsteam_pp_overlap_affinity_info:
    '玩第一列主游戏的玩家比一般用户更有可能玩的4个游戏，即该游戏的玩家玩其他游戏的比率除以一般用户玩的比率得到的倍数最高的四个游戏。',
  dbi_overlapsteam_pw_overlap_affinity: '游戏玩家的Wishlist亲密度',
  dbi_overlapsteam_pw_overlap_affinity_info:
    '玩第一列主游戏的玩家比一般用户更有可能添加到愿望清单的4个游戏，即该游戏的玩家添加其他游戏到愿望清单的比率除以一般用户添加其他游戏到愿望清单的比率得到的倍数最高的四个游戏。',
  dbi_overlapsteam_wp_overlap_affinity: 'Wishlist用户的玩游戏亲密度',
  dbi_overlapsteam_wp_overlap_affinity_info:
    '添加第一列主游戏到愿望清单的玩家比一般用户更有可能玩的4个游戏。即添加主游戏到愿望清单的玩家玩其他游戏的比率除以一般用户玩的比率得到的倍数最高的四个游戏。',
  dbi_overlapsteam_ww_overlap_affinity: 'Wishlist用户的Wishlist亲密度',
  dbi_overlapsteam_ww_overlap_affinity_info:
    '添加第一列主游戏到愿望清单的玩家比一般用户更有可能添加到愿望清单的4个游戏。',
  dbi_overlapsteam_played_play_info:
    '玩第一列主游戏的玩家最常玩的4个游戏，即出现在主游戏玩家游戏库中最多的4个游戏，也是游戏玩家重叠度最高的4个游戏。',
  dbi_overlapsteam_played_wishlist: '玩家同时添加愿望清单',
  dbi_overlapsteam_played_wishlist_info:
    '玩第一列主游戏的玩家最常添加到愿望清单的4个游戏，即出现在主游戏玩家愿望清单中最多的4个游戏。',
  dbi_overlapsteam_wishlisted_play: '添加愿望清单同时玩',
  dbi_overlapsteam_wishlisted_play_info:
    '添加第一列主游戏到愿望清单的玩家最常玩的4个游戏。即添加主游戏到愿望清单的玩家游戏库中最多的4个游戏，也是添加愿望清单同时玩得最多的4个游戏。',
  dbi_overlapsteam_wishlisted_wishlist: '添加愿望清单同时添加愿望清单',
  dbi_overlapsteam_wishlisted_wishlist_info: '添加第一列主游戏到愿望清单的玩家最常添加到愿望清单的4个游戏。',
  dbi_overlapsteam_pw_overlap_affinity_detail: 'Wishlist用户的玩游戏亲密度',
  dbi_overlapsteam_pw_overlap_affinity_detail_info:
    // `跟所有玩家相比，添加本游戏到愿望清单的玩家玩其他游戏的可能性倍数。计算方式：添加游戏1到愿望清单同时玩游戏2且游戏时长大于【参与度】的玩家比例 / 所有玩家中玩游戏2且游戏时长大于【参与度】的玩家比例。{br}举例：假设样本玩家300万，把CS2添加到愿望清单的玩家有50万，博德之门3的玩家有30万，将CS2添加到愿望清单同时玩博德之门3的玩家有10万，那么将CS2添加到愿望清单的玩家中同时玩博德之门3的百分比为10万/50万=20%，所有样本玩家玩博德之门3的比例是30万/300万=10%，则相比一般用户，CS2的Wishlist玩家玩博德之门3的可能性倍数为20%/10%=2.0x。`,
    `
    定义：跟所有玩家相比，添加本游戏到愿望清单的玩家玩其他游戏的可能性倍数。
    {br}计算方式：添加游戏A到愿望清单同时玩游戏B且游戏时长大于【游玩时长】的玩家比例 / 所有玩家中玩游戏B且游戏时长大于【游玩时长】的玩家比例。
    {br}举例：假设样本玩家300万，把CS2添加到愿望清单的玩家有50万，博德之门3的玩家有30万，将CS2添加到愿望清单同时玩博德之门3的玩家有10万，那么将CS2添加到愿望清单的玩家中同时玩博德之门3的百分比为10万/50万=20%，所有样本玩家玩博德之门3的比例是30万/300万=10%，则相比大盘用户，CS2的Wishlist玩家玩博德之门3的可能性倍数为20%/10%=2.0x。
  `,
  dbi_overlapsteam_ww_overlap_affinity_detail: 'Wishlist用户的Wishlist亲密度',
  dbi_overlapsteam_ww_overlap_affinity_detail_info:
    //  `跟所有玩家相比，添加本游戏到愿望清单的玩家同时添加其他游戏的可能性倍数。计算方式：同时添加游戏1和游戏2到愿望清单的玩家比例 / 所有玩家中添加游戏2到愿望清单的比例。{br}举例：假设样本玩家300万，把CS2添加到愿望清单的玩家有50万，添加博德之门3到愿望清单的玩家有30万，同时把CS2和博德之门3到愿望清单的玩家有10万，那么将CS2添加到愿望清单的玩家中同时添加博德之门3的玩家百分比为10万/50万=20%，所有样本玩家添加博德之门3的比例是30万/300万=10%，则相比一般用户，CS2的Wishlist玩家同时添加博德之门3的可能性倍数为20%/10%=2.0x。`,
    `
    定义：跟所有玩家相比，添加本游戏到愿望清单的玩家同时添加其他游戏的可能性倍数。
    {br}计算方式：同时添加游戏A和游戏B到愿望清单的玩家比例 / 所有玩家中添加游戏B到愿望清单的比例。
    {br}举例：假设样本玩家300万，把CS2添加到愿望清单的玩家有50万，添加博德之门3到愿望清单的玩家有30万，同时把CS2和博德之门3到愿望清单的玩家有10万，那么将CS2添加到愿望清单的玩家中同时添加博德之门3的玩家百分比为10万/50万=20%，所有样本玩家添加博德之门3的比例是30万/300万=10%，则相比大盘用户，CS2的Wishlist玩家同时wishlist博德之门3的可能性倍数为20%/10%=2.0x。
  `,
  dbi_overlapsteam_overlap_affinity: '游戏玩家亲密度',
  dbi_overlapsteam_overlap_affinity_info:
    // '跟所有玩家相比，本游戏玩家玩其他游戏的可能性倍数。计算方式：游戏1玩家同时玩游戏2的重叠度 / 所有玩家中玩游戏2的比例。{br}举例：假设样本玩家300万，CS2玩家50万，PUBG玩家30万，CS2和PUBG都玩的玩家有20万，则CS2玩家同时玩PUBG的重叠度为20万/50万=40%，所有玩家玩PUBG的比例为30万/300万=10%。CS2玩家玩PUBG的亲密度为40%/10%=4，4倍表示为4x。',
    `
    定义：跟所有玩家相比，本游戏玩家玩其他游戏的可能性倍数。
    {br}计算方式：游戏A玩家同时玩游戏B的重叠度 / 所有玩家中玩游戏B的比例。
    {br}举例：假设样本玩家300万，CS2玩家50万，PUBG玩家30万，CS2和PUBG都玩的玩家有20万，则CS2玩家同时玩PUBG的重叠度为20万/50万=40%，所有玩家玩PUBG的比例为30万/300万=10%。CS2玩家玩PUBG的亲密度为40%/10%=4，4倍表示为4x。
  `,
  dbi_overlapsteam_overlap_affinity_pw: '游戏玩家的Wishlist亲密度',
  dbi_overlapsteam_overlap_affinity_info_pw:
    // `跟所有玩家相比，本游戏玩家添加其他游戏到愿望清单的可能性倍数。计算方式：游戏时长大于【参与度】的游戏1玩家中同时添加游戏2到愿望清单的比例 / 所有玩家中添加游戏2到愿望清单的比例。{br}举例：假设样本玩家300万，CS2玩家50万，把博德之门3添加到愿望清单的玩家有30万，同时玩CS2且将博德之门3添加到愿望清单的玩家有10万，那么CS2的玩家中同时添加博德之门3到愿望清单的百分比为10万/50万=20%，所有样本玩家添加游戏2到愿望清单的比例是30万/300万=10%，则相比一般用户，CS2的玩家添加博德之门3到愿望清单的可能性倍数为20%/10%=2.0x。`,
    `
    定义：跟所有玩家相比，本游戏玩家添加其他游戏到愿望清单的可能性倍数。
    {br}计算方式：游玩时长大于筛选值的游戏A玩家中同时添加游戏B到愿望清单的比例 / 所有玩家中添加游戏B到愿望清单的比例。
    {br}举例：假设样本玩家300万，CS2玩家50万，把博德之门3添加到愿望清单的玩家有30万，同时玩CS2且将博德之门3添加到愿望清单的玩家有10万，那么CS2的玩家中同时添加博德之门3到愿望清单的百分比为10万/50万=20%，所有样本玩家添加游戏B到愿望清单的比例是30万/300万=10%，则相比大盘用户，CS2的玩家添加博德之门3到愿望清单的可能性倍数为20%/10%=2.0x。
  `,
  dbi_overlapsteam_weighted_playtime: '加权玩家游玩时长',
  dbi_overlapsteam_weighted_playtime_info: `玩本游戏的玩家玩B游戏的时长/玩本游戏的玩家数。计算方式：play hour on Game B = {游戏库中有app_id_A的所有玩家在app_id_B上的play_minutes总和} / {游戏库中有app_id_A的玩家数 * 60}`,
  dbi_overlapsteam_played_play_percent: '游戏玩家重叠度',
  dbi_overlapsteam_played_play_percent_info:
    // '本游戏玩家还玩其他游戏的百分比。计算方式：游戏1玩家同时玩游戏2的重叠度 = {游戏库中同时有游戏1和游戏 2，且在游戏1和游戏2上的游玩时间 > 您选择的参与度的玩家数} / {游戏库中有游戏1的玩家数}。{br}举例：假设样本玩家300万，CS2玩家50万，PUBG玩家30万，CS2和PUBG都玩的玩家有20万，则CS2玩家同时玩PUBG的重叠度为20万/50万=40%。',
    `
    定义：本游戏玩家还玩其他游戏的百分比。
    {br}计算方式：游戏A玩家同时玩游戏B的重叠度 = {游戏库中同时有游戏A和游戏 B，且在游戏A和游戏B上的游玩时间 > 您筛选的游玩时长的玩家数} / {游戏库中有游戏A的玩家数}。
    {br}举例：假设样本玩家300万，CS2玩家50万，PUBG玩家30万，CS2和PUBG都玩的玩家有20万，则CS2玩家同时玩PUBG的重叠度为20万/50万=40%。
  `,
  dbi_overlapsteam_average_playtime: '平均游玩时长',
  dbi_overlapsteam_played_average_playtime_info:
    // `重叠玩家玩游戏2的平均游戏时长。计算方式：玩游戏1且游戏时长大于【参与度】同时还在玩游戏2且游戏时长大于【参与度】的玩家在游戏2的总游玩时长 / 玩游戏1且游戏时长大于【参与度】同时还在玩游戏2且游戏时长大于【参与度】的玩家数{br}举例：假设同时玩CS2和PUBG的玩家有10万，这10万玩家在PUBG的总游玩时长为100万个小时，则平均游戏时长=100万/10万=10h`,
    `
    定义：重叠玩家玩游戏B的平均游戏时长。
    {br}计算方式：玩游戏A且游玩时长大于筛选值同时还在玩游戏B且游玩时长大于筛选值的玩家在游戏B的总游玩时长 / 筛选游玩时长后的玩家数
    {br}举例：假设同时玩CS2和PUBG的玩家有10万，这10万玩家在PUBG的总游玩时长为100万个小时，则平均游戏时长=100万/10万=10h
  `,
  dbi_overlapsteam_wishlist_average_playtime_info:
    // `将游戏1添加到愿望清单的同时还在玩游戏2的玩家玩游戏2的平均游戏时长。计算方式：将游戏1添加到愿望清单的同时还在玩游戏2且游戏时长大于【参与度】的玩家在游戏2的总游玩时长 / 将游戏1添加到愿望清单的同时还在玩游戏2且游戏时长大于【参与度】的玩家数{br}举例：假设将CS2添加到愿望清单同时也在玩博德之门3的玩家有10万，这10万玩家在博德之门3的总游玩时长为100万个小时，则平均游戏时长=100万/10万=10h`,
    `
    定义：将游戏A添加到愿望清单的同时还在玩游戏B的玩家玩游戏B的平均游戏时长。
    {br}计算方式：将游戏A添加到愿望清单的同时还在玩游戏B且游玩时长大于筛选值的玩家在游戏B的总游玩时长 / 这类玩家数
    {br}举例：假设将CS2添加到愿望清单同时也在玩博德之门3的玩家有10万，这10万玩家在博德之门3的总游玩时长为100万个小时，则平均游戏时长=100万/10万=10h
  `,
  dbi_overlapsteam_played_wishlist_percent: '玩家同时添加愿望清单百分比',
  dbi_overlapsteam_played_wishlist_percent_info:
    // '本游戏玩家添加其他游戏到愿望清单的百分比。计算方式：游戏1玩家同时添加游戏2到愿望清单的重叠度 = {游戏库中有游戏1且游玩时长超过您选择参与度且愿望清单中有游戏2的玩家数} / {游戏库中有游戏1的玩家数}。{br}举例：假设样本玩家300万，CS2玩家50万，同时玩CS2且将博德之门3添加到愿望清单的玩家有10万。那么玩CS2同时添加博德之门3到愿望清单的玩家百分比为10万/50万=20%。',
    `
      定义：本游戏玩家添加其他游戏到愿望清单的百分比。
      {br}计算方式：游戏A玩家同时添加游戏B到愿望清单的重叠度 = {游戏库中有游戏A且游玩时长超过您筛选游玩时长且愿望清单中有游戏B的玩家数} / {游戏库中有游戏A的玩家数}。
      {br}举例：假设样本玩家300万，CS2玩家50万，同时玩CS2且将博德之门3添加到愿望清单的玩家有10万。那么玩CS2同时添加博德之门3到愿望清单的玩家百分比为10万/50万=20%。
    `,
  dbi_overlapsteam_wishlisted_play_percent: `添加愿望清单同时玩游戏的百分比`,
  dbi_overlapsteam_wishlisted_play_percent_info:
    // `将本游戏添加到愿望清单的同时还玩其他游戏的百分比。计算方式：将本游戏添加到愿望清单的同时还玩其他游戏的百分比 = {wishlist列表中有游戏1且游戏库中有游戏 2，同时在游戏2上的游玩时间 > 您选择的参与度的玩家数} / {wishlist列表中有游戏1的玩家数}。{br}举例：假设样本玩家300万，将CS2加入愿望清单的玩家有50万，将CS2加入愿望清单且同时玩博德之门3的玩家有20万，则将CS2加入愿望清单且同时玩博德之门3的玩家重叠度为20万/50万=40%。`,
    `
    定义：将本游戏添加到愿望清单的同时还玩其他游戏的百分比。
    {br}计算方式：将本游戏添加到愿望清单的同时还玩其他游戏的百分比 = {wishlist列表中有游戏A且游戏库中有游戏 B，同时在游戏B上的游玩时间 > 您筛选的游玩时长的玩家数} / {wishlist列表中有游戏A的玩家数}。
    {br}举例：假设样本玩家300万，将CS2加入愿望清单的玩家有50万，将CS2加入愿望清单且同时玩博德之门3的玩家有20万，则将CS2加入愿望清单且同时玩博德之门3的玩家重叠度为20万/50万=40%。
  `,
  dbi_overlapsteam_weighted_playtime_wish: `加权愿望清单玩家游玩时长`,
  dbi_overlapsteam_weighted_playtime_wish_info: `添加A游戏到愿望清单的玩家在其他游戏的加权游玩时长。计算方式：play hour on Game B = {wishlist中有app_id_A的所有玩家在app_id_B上的play_minutes总和} / {wishilist中有app_id_A的玩家数 * 60}`,
  dbi_overlapsteam_wishlisted_wishlist_percent: `添加愿望清单同时添加愿望清单百分比`,
  dbi_overlapsteam_wishlisted_wishlist_percent_info:
    // `同时将本游戏和其他游戏添加到愿望清单的百分比。计算方式：同时将本游戏和其他游戏添加到愿望清单的百分比 = {wishlist列表中同时有游戏1和游戏 2的玩家数} / {wishlist列表中有游戏1的玩家数}。{br}假设样本玩家300万，将CS2加入愿望清单的玩家有50万，同时将CS2和博德之门3加入愿望清单的玩家有20万，则同时将CS2和博德之门3加入愿望清单的玩家重叠度为20万/50万=40%。`,
    `
    定义：同时将本游戏和其他游戏添加到愿望清单的百分比。
    {br}计算方式：同时将本游戏和其他游戏添加到愿望清单的百分比 = {wishlist列表中同时有游戏A和游戏 B的玩家数} / {wishlist列表中有游戏A的玩家数}。
    {br}举例：假设样本玩家300万，将CS2加入愿望清单的玩家有50万，同时将CS2和博德之门3加入愿望清单的玩家有20万，则同时将CS2和博德之门3加入愿望清单的玩家重叠度为20万/50万=40%。
  `,
  dbi_overlapsteam_release_time: `Steam上显示的游戏上线时间`,
  dbi_overlapsteam_continuously_updated: `本页数据每周更新，仅包括PCU超过 1000的游戏。`,
  dbi_overlapsteam_data_frequency: `数据描述`,

  dbi_pcconsole_source_mscience_first: '提供PC/Console游戏的',
  dbi_overlap_other_vendor_data_description:
    '重合数据计算范围为各平台全球热度前 200 款游戏，同时纳入各国家榜单前 100 款游戏。',
  dbi_overlap_other_vendor_active_users_range: '重叠活跃用户区间',

  dbi_pcconsole_source_mscience_second: 'Digital Revenue',
  // dbi_pcconsole_source_mscience_third: '，仅',
  // dbi_pcconsole_source_mscience_fourth: '美国',
  dbi_pcconsole_source_mscience_third: '，仅限',
  dbi_pcconsole_source_mscience_fourth: '美、英、法、德、西',
  dbi_pcconsole_source_mscience_fifth: '，有日/月粒度数据',

  dbi_pcconsole_source_npd_first: '提供PC/Console游戏的',
  dbi_pcconsole_source_npd_second: 'Physical Revenue',
  dbi_pcconsole_source_npd_third: '，仅',
  dbi_pcconsole_source_npd_fourth: '美国',
  dbi_pcconsole_source_npd_fifth: '，仅',
  dbi_pcconsole_source_npd_sixth: '月',
  dbi_pcconsole_source_npd_seventh: '度数据',

  dbi_pcconsole_source_vginsight_first: '提供仅 PC ',
  dbi_pcconsole_source_vginsight_second: 'Steam游戏',
  dbi_pcconsole_source_vginsight_third: '的Steam Revenue，仅全球',
  dbi_pcconsole_source_vginsight_fourth: '不可分国家',
  dbi_pcconsole_source_vginsight_fifth: '，有日/周/月粒度数据',

  dbi_pcconsole_source_gamalytic_first: '提供仅 PC ',
  dbi_pcconsole_source_gamalytic_second: 'Steam游戏',
  dbi_pcconsole_source_gamalytic_third: '的Steam Revenue，仅全球',
  dbi_pcconsole_source_gamalytic_fourth: '不可分国家',
  dbi_pcconsole_source_gamalytic_fifth: '，有日/周/月粒度数据',

  dbi_pcconsole_source_alinea_first: '提供PC/Console游戏的',
  dbi_pcconsole_source_alinea_second: 'Revenue',
  dbi_pcconsole_source_alinea_third: '，仅全球',
  dbi_pcconsole_source_alinea_fourth: '不可分国家',
  dbi_pcconsole_source_alinea_fifth: '，有日/周/月粒度数据',

  dbi_pcconsole_source_gsd_first: '提供PC/Console游戏的',
  dbi_pcconsole_source_gsd_second: 'Digital & Physical Revenue',
  dbi_pcconsole_source_gsd_third: '，主要覆盖',
  dbi_pcconsole_source_gsd_fourth: '欧美及部分亚洲国家',
  dbi_pcconsole_source_gsd_fifth: '，仅',
  dbi_pcconsole_source_gsd_sixth: '周',
  dbi_pcconsole_source_gsd_seventh: '数据',

  dbi_pcconsole_source_collapse: '收起',
  dbi_pcconsole_source_show: '展开',
  dbi_pcconsole_source_metrics_explanation: '指标解释',
  dbi_pcconsole_source_differences_explanation: '数据源区别说明',
  dbi_pcconsole_source_explanation: '说明',
  // DataBrain split text for differences explanation
  dbi_pcconsole_source_databrain_first: 'DataBrain校准数据。提供PC/Console游戏的',
  dbi_pcconsole_source_databrain_second: '线上和零售加总收入及销量',
  dbi_pcconsole_source_databrain_third: '，仅全球',
  dbi_pcconsole_source_databrain_fourth: '不可分国家',
  dbi_pcconsole_source_databrain_fifth: '，有日/周/月粒度数据。',
  // Other Vendor split text for differences explanation
  dbi_pcconsole_source_othervendor_first: '提供PC/Console游戏的',
  dbi_pcconsole_source_othervendor_second: '用户活跃指标',
  dbi_pcconsole_source_othervendor_third: '，覆盖',
  dbi_pcconsole_source_othervendor_fourth: '全球48个国家',
  dbi_pcconsole_source_othervendor_fifth: '，有日/月粒度数据',
};
